export const SCRATCH_PAUSE = 1500;
export const ADJUSTS_PAUSE = 30000;
